/*
 * @Author: hzm
 * @Date: 2022-12-14 14:17:54
 * @Description:
 */
/*
 * @Author: hzm
 * @Date: 2022-07-11 16:36:47
 * @Description:
 */

export default function () {
  const todoDetailDialog = reactive({
    open: false,
    detail: '',
    title: '',
  });

  function openMsgDialog(message: API.TodoTask) {
    todoDetailDialog.detail = message.content ?? '';
    todoDetailDialog.open = true;
    todoDetailDialog.title = message.title ?? '';
  }

  return {
    todoDetailDialog,
    openMsgDialog,
  };
}
